import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function isArchiveFolder(folderId) {
    var archiveFolderId = getUserConfiguration().UserOptions.ArchiveFolderId;
    return folderId && archiveFolderId && archiveFolderId == folderId;
}
//# sourceMappingURL=isArchiveFolder.js.map